import { Link } from "react-router";
import theme from "@/constants/theme";
import { routes } from "@/constants/routes";

const AdminHome = () => {
  const models = [
    {
      name: "Rutas",
      description: "Administra las rutas de la aplicación",
      href: routes.admin.routes.root,
    },
    {
      name: "Usuarios",
      description: "Administra los usuarios de la aplicación",
      href: routes.admin.users.root,
    },
  ];

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: 32,
        padding: 16,
        paddingTop: 32,
      }}
    >
      {/* <span style={{ color: theme.colors.text.caption }}>Home / Admin</span> */}
      <h1 style={{ color: theme.colors.text.title }}>Admin Home</h1>
      <ul
        style={{
          listStyle: "none",
          paddingLeft: 0,
          display: "flex",
          flexDirection: "column",
          gap: 16,
        }}
      >
        {models.map((model, index) => (
          <Link to={model.href} key={index}>
            <li
              style={{
                display: "flex",
                gap: 4,
                backgroundColor: theme.colors.background.secondary,
                padding: 16,
                justifyContent: "center",
                flexDirection: "column",
                borderRadius: 8,
                paddingInline: 32,
              }}
            >
              <h2 style={{ color: theme.colors.text.body }}>{model.name}</h2>
              <p style={{ color: theme.colors.text.caption }}>
                {model.description}
              </p>
            </li>
          </Link>
        ))}
      </ul>
    </div>
  );
};

export default AdminHome;
